import { render } from "./Notification_Bell.vue?vue&type=template&id=67361fd4"
import script from "./Notification_Bell.vue?vue&type=script&lang=js"
export * from "./Notification_Bell.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__